import React from 'react';
import { 
  LoadingSpinner 
} from '../../../components/common/StyledComponents';
import BrandLogo from '../../../components/common/BrandLogo';
import {
  AuthContainer,
  AuthCard,
  LogoSection,
  AuthSubtitle,
  FormSection,
  StyledTextField,
  PasswordField,
  ButtonSection,
  ModernButton,
  Alert,
  ToggleSection,
  ToggleButton,
  PasswordToggle,
} from '../../../components/common/AuthLayout';
import { useRegisterForm } from '../../../hooks/auth/useAuthForm';

const Register = () => {
  const {
    formData,
    showPassword,
    showConfirmPassword,
    validationErrors,
    loading,
    error,
    handleInputChange,
    handleSubmit,
    handleKeyPress,
    goToLogin,
    togglePasswordVisibility,
    toggleConfirmPasswordVisibility,
  } = useRegisterForm();

  return (
    <AuthContainer>
      <AuthCard maxWidth="440px">
        <LogoSection>
          <BrandLogo height={32} />
          <AuthSubtitle>무료 첨삭 체험을 시작하세요</AuthSubtitle>
        </LogoSection>

        <FormSection onSubmit={handleSubmit}>

        <StyledTextField error={!!validationErrors.name}>
            <label>이름</label>
            <input
              type="text"
              value={formData.name}
              onChange={handleInputChange('name')}
              onKeyPress={handleKeyPress}
              disabled={loading}
              placeholder="이름을 입력하세요"
            />
            {validationErrors.name && (
              <div className="error-message">{validationErrors.name}</div>
            )}
          </StyledTextField>
          
          <StyledTextField error={!!validationErrors.id}>
            <label>이메일 (로그인 ID)</label>
            <input
              type="email"
              autoComplete="email"
              value={formData.id}
              onChange={handleInputChange('id')}
              onKeyPress={handleKeyPress}
              disabled={loading}
              placeholder="예: name@example.com"
            />
            {validationErrors.id && (
              <div className="error-message">{validationErrors.id}</div>
            )}
          </StyledTextField>

          <StyledTextField error={!!validationErrors.phone}>
            <label>전화번호</label>
            <input
              type="tel"
              autoComplete="tel"
              value={formData.phone}
              onChange={handleInputChange('phone')}
              onKeyPress={handleKeyPress}
              disabled={loading}
              placeholder="숫자만 10~11자리 (하이픈 없이)"
            />
            {validationErrors.phone && (
              <div className="error-message">{validationErrors.phone}</div>
            )}
          </StyledTextField>
          
          
          <PasswordField error={!!validationErrors.password}>
            <label>비밀번호</label>
            <input
              type={showPassword ? 'text' : 'password'}
              value={formData.password}
              onChange={handleInputChange('password')}
              onKeyPress={handleKeyPress}
              disabled={loading}
              placeholder="비밀번호를 입력하세요"
            />
            <PasswordToggle
              visible={showPassword}
              onClick={togglePasswordVisibility}
              disabled={loading}
            />
            {validationErrors.password && (
              <div className="error-message">{validationErrors.password}</div>
            )}
          </PasswordField>

          <PasswordField error={!!validationErrors.confirmPassword}>
            <label>비밀번호 확인</label>
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              value={formData.confirmPassword}
              onChange={handleInputChange('confirmPassword')}
              onKeyPress={handleKeyPress}
              disabled={loading}
              placeholder="비밀번호를 다시 입력하세요"
            />
            <PasswordToggle
              visible={showConfirmPassword}
              onClick={toggleConfirmPasswordVisibility}
              disabled={loading}
            />
            {validationErrors.confirmPassword && (
              <div className="error-message">{validationErrors.confirmPassword}</div>
            )}
          </PasswordField>

          {error && (
            <Alert severity="error">
              {error}
            </Alert>
          )}

          <ButtonSection>
            <ModernButton
              type="submit"
              variant="primary"
              disabled={loading}
            >
              {loading ? <LoadingSpinner /> : '회원가입'}
            </ModernButton>
          </ButtonSection>
        </FormSection>

        <ToggleSection>
          <ToggleButton type="button" onClick={goToLogin}>
            이미 계정이 있으신가요?<strong>로그인</strong>
          </ToggleButton>
        </ToggleSection>
      </AuthCard>
    </AuthContainer>
  );
};

export default Register; 